let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ksTQ6")).then(() => parcelRequire('4EAWY'));